import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer, Bounce } from "react-toastify";
import { PublicLayout } from "./layout";
import { HomePage, GenerateInvoicePage } from "./pages";


export default function AppRoutes() {
    return (
        <>
            <Routes>
                <Route path="/" element={<PublicLayout><HomePage /></PublicLayout>} />
                <Route path="/generate-invoice" element={<GenerateInvoicePage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <AppToastContainer />
        </>
    );
}

const AppToastContainer = () => {
    const toastContainerProps: any = {
        autoClose: 5000,
        draggable: false,
        theme: 'colored',
        position: 'bottom-right',
        transition: Bounce
    };
    return <ToastContainer {...toastContainerProps} />;
}